import CityDirectory from "../components/CityDirectory";

export default function AuCities() {
  return (
    <CityDirectory
      id="au-cities"
      title="Australia City Guides"
      subtitle="50+ places across every state and territory — capital cities, coastal escapes, outback towns and icons like Uluru, the Great Barrier Reef and the Whitsundays."
      endpoint="/geo/au-cities"
      country="Australia"
      searchPlaceholder="Search a city or state — try Sydney, Tasmania, Cairns…"
      accent="#b8860b"
      docTitle="Australia City Guides — Cities by State | TravelerPulse"
    />
  );
}
